// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"840233839e57782d497e","243":"307c1cf31df043fbcfea","498":"38265b2345dff3fa4179","556":"f4a742c0e9de8a7a55f0","595":"f7776ac79a7da92f941a"}[chunkId] + ".bundle.js";
};